import { render, staticRenderFns } from "./CheckoutBtn.vue?vue&type=template&id=657074cc&scoped=true&"
import script from "./CheckoutBtn.vue?vue&type=script&lang=js&"
export * from "./CheckoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutBtn.vue?vue&type=style&index=0&id=657074cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657074cc",
  null
  
)

export default component.exports